import html from "../images/Skill/html-5.webp";
import css from "../images/Skill/css-3.webp";
import js from "../images/Skill/js.webp";
import php from "../images/Skill/php.webp";
import react from "../images/Skill/react.webp";
import ts from "../images/Skill/typescript.webp";
import tailwind from "../images/Skill/tailwind-css.webp";
import nextjs from "../images/Skill/nextjs.webp";
import nestjs from "../images/Skill/nestjs.webp";
import mysql from "../images/Skill/mysql.webp";
import pg from "../images/Skill/pg.webp";
import asp from "../images/Skill/asp.webp";

export const skillsData = [
  { skill: "HTML", logo: html },
  { skill: "CSS", logo: css },
  { skill: "JavaScript", logo: js },
  { skill: "PHP", logo: php },
  { skill: "TypeScript", logo: ts },
  { skill: "ReactJS", logo: react },
  { skill: "NextJS", logo: nextjs },
  { skill: "NestJS", logo: nestjs },
  { skill: "ASP.NET", logo: asp },
  { skill: "PostgreSQL", logo: pg },
  { skill: "MySQL", logo: mysql },
  { skill: "TailwindCSS", logo: tailwind },
];
